(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  document.documentElement.classList.add("js-reveal-ready");

  if (reduceMotion || !("IntersectionObserver" in window)) {
    document.querySelectorAll("main#MainContent .shopify-section").forEach(function (el) {
      el.classList.add("is-revealed");
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-revealed");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.08, rootMargin: "0px 0px -60px 0px" }
  );

  document.querySelectorAll("main#MainContent .shopify-section").forEach(function (el) {
    observer.observe(el);
  });
})();
